const dollar = '$';
const dollarRegex = /\d(?=(\d{3})+\.)/g;
const dollarReplace = '$&,';
const commas = /,/g;

export function currency(amount, decimal = 2, noZero = false) {
  return dollar + thousand(amount, decimal, noZero);
}

export function thousand(amountRaw, decimal = 2, noZero = true) {
  const amount = String(amountRaw).replace(commas, '');
  const value = parseFloat(amount).toFixed(decimal || 2).replace(dollarRegex, dollarReplace);
  const [whole, decimals] = value.split('.');
  return noZero && parseInt(decimals) === 0 ? whole : value;
}
